import React from 'react';
import ReactDOM from 'react-dom';
import Config from './utils/config';

import FilteredActivityList from './FilteredActivityList';

const activityList = document.getElementById('filtered-activity-list');
Config.init(activityList.dataset);

ReactDOM.render(
	<FilteredActivityList heading={Config.get('heading')} urlback={Config.get('urlback')} />,
	activityList
);
